import { useEffect, useState } from "react";
import { SectionCheckBox } from "./SectionCheckBox";
import { Box, Grid } from "@mui/material";
import { AsarFormikInput } from "@/components";

export default function Sections({ dataForm, setDataForm, update }) {
  const [checkedEducation, setCheckedEducation] = useState(
    update
      ? (dataForm?.medicalSections ?? []).indexOf("EDUCATIONAL") !== -1
      : false,
  );
  const [checkedOptometry, setCheckedOptometry] = useState(
    update
      ? (dataForm?.medicalSections ?? []).indexOf("OPTOMETRY") !== -1
      : false,
  );
  const [checkedMidwifery, setCheckedMidwifery] = useState(
    update
      ? (dataForm?.medicalSections ?? []).indexOf("MIDWIFERY") !== -1
      : false,
  );
  const [checkedAudiologists, setCheckedAudiologists] = useState(
    update
      ? (dataForm?.medicalSections ?? []).indexOf("AUDIOLOGIST") !== -1
      : false,
  );
  const [checkedPsychology, setCheckedPsychology] = useState(
    update
      ? (dataForm?.medicalSections ?? []).indexOf("PSYCHOLOGY") !== -1
      : false,
  );
  const [checkedLaboratory, setCheckedLaboratory] = useState(
    update
      ? (dataForm?.medicalSections ?? []).indexOf("LABORATORY") !== -1
      : false,
  );
  const [checkedPhysiotherapy, setCheckedPhysiotherapy] = useState(
    update
      ? (dataForm?.medicalSections ?? []).indexOf("PHYSIOTHERAPY") !== -1
      : false,
  );
  const [checkedDentistry, setCheckedDentistry] = useState(
    update ? (dataForm?.medicalSections ?? []).indexOf("DENTAL") !== -1 : false,
  );
  const [checkedErrand, setCheckedErrand] = useState(
    update
      ? (dataForm?.medicalSections ?? []).indexOf("REFERRAL") !== -1
      : false,
  );

  useEffect(() => {
    if (update) {
      setCheckedEducation(
        (dataForm?.medicalSections ?? []).indexOf("EDUCATIONAL") !== -1,
      );
      setCheckedOptometry(
        (dataForm?.medicalSections ?? []).indexOf("OPTOMETRY") !== -1,
      );

      setCheckedMidwifery(
        (dataForm?.medicalSections ?? []).indexOf("MIDWIFERY") !== -1,
      );
      setCheckedAudiologists(
        (dataForm?.medicalSections ?? []).indexOf("AUDIOLOGIST") !== -1,
      );
      setCheckedPsychology(
        (dataForm?.medicalSections ?? []).indexOf("PSYCHOLOGY") !== -1,
      );
      setCheckedLaboratory(
        (dataForm?.medicalSections ?? []).indexOf("LABORATORY") !== -1,
      );
      setCheckedPhysiotherapy(
        (dataForm?.medicalSections ?? []).indexOf("PHYSIOTHERAPY") !== -1,
      );
      setCheckedDentistry(
        (dataForm?.medicalSections ?? []).indexOf("DENTAL") !== -1,
      );
      setCheckedErrand(
        (dataForm?.medicalSections ?? []).indexOf("REFERRAL") !== -1,
      );
    }
  }, [update]);

  return (
    <Box
      display={"flex"}
      flexDirection={"row"}
      flexWrap={"wrap"}
      gap={"5px"}
      rowGap={"5px"}
      mr={"-25px"}
    >
      <SectionCheckBox
        label="آموزش"
        onChange={(e) => {
          if ((dataForm?.medicalSections ?? []).indexOf("EDUCATIONAL") !== -1) {
            setDataForm({
              ...dataForm,
              medicalSections: dataForm?.medicalSections.filter(
                (itr) => itr !== "EDUCATIONAL",
              ),
            });
          } else {
            let tmp = dataForm?.medicalSections ?? [];
            tmp.push("EDUCATIONAL");
            setDataForm({
              ...dataForm,
              medicalSections: tmp,
            });
          }
          setCheckedEducation(e.target.value);
        }}
        checked={checkedEducation}
      />
      {checkedEducation && (
        <>
          <SectionCheckBox
            onChange={(e) =>
              setDataForm({ ...dataForm, adultEducation: e.target.checked })
            }
            checked={dataForm.adultEducation}
            label=" آموزش بزرگسالان"
          />
          <SectionCheckBox
            onChange={(e) =>
              setDataForm({ ...dataForm, childEducation: e.target.checked })
            }
            checked={dataForm.childEducation}
            label="آموزش کودکان"
          />
        </>
      )}

      <SectionCheckBox
        label="بینایی سنجی"
        onChange={(e) => {
          if ((dataForm?.medicalSections ?? []).indexOf("OPTOMETRY") !== -1) {
            setDataForm({
              ...dataForm,
              medicalSections: dataForm?.medicalSections.filter(
                (itr) => itr !== "OPTOMETRY",
              ),
            });
          } else {
            let tmp = dataForm?.medicalSections ?? [];
            tmp.push("OPTOMETRY");
            setDataForm({
              ...dataForm,
              medicalSections: tmp,
            });
          }
          setCheckedOptometry(e.target.value);
        }}
        checked={checkedOptometry}
      />
      {checkedOptometry && (
        <>
          <SectionCheckBox
            onChange={(e) =>
              setDataForm({ ...dataForm, freeGlass: e.target.checked })
            }
            checked={dataForm.freeGlass}
            label="اهدای رایگان عینک"
          />
        </>
      )}
      <SectionCheckBox
        label="شنوایی سنجی"
        onChange={(e) => {
          if ((dataForm?.medicalSections ?? []).indexOf("AUDIOLOGIST") !== -1) {
            setDataForm({
              ...dataForm,
              medicalSections: dataForm?.medicalSections.filter(
                (itr) => itr !== "AUDIOLOGIST",
              ),
            });
          } else {
            let tmp = dataForm?.medicalSections ?? [];
            tmp.push("AUDIOLOGIST");
            setDataForm({
              ...dataForm,
              medicalSections: tmp,
            });
          }
          setCheckedAudiologists(e.target.value);
        }}
        checked={checkedAudiologists}
      />
      {checkedAudiologists && (
        <>
          <SectionCheckBox
            onChange={(e) =>
              setDataForm({ ...dataForm, freeHearingAids: e.target.checked })
            }
            checked={dataForm.freeHearingAids}
            label="اهدای رایگان سمعک"
          />
        </>
      )}

      <SectionCheckBox
        label="مامایی"
        onChange={(e) => {
          if ((dataForm?.medicalSections ?? []).indexOf("MIDWIFERY") !== -1) {
            setDataForm({
              ...dataForm,
              medicalSections: dataForm?.medicalSections.filter(
                (itr) => itr !== "MIDWIFERY",
              ),
            });
          } else {
            let tmp = dataForm?.medicalSections ?? [];
            tmp.push("MIDWIFERY");
            setDataForm({
              ...dataForm,
              medicalSections: tmp,
            });
          }
          setCheckedMidwifery(e.target.value);
        }}
        checked={checkedMidwifery}
      />
      {checkedMidwifery && (
        <>
          <SectionCheckBox
            onChange={(e) =>
              setDataForm({ ...dataForm, popEsmirTest: e.target.checked })
            }
            checked={dataForm.popEsmirTest}
            label="تست پاپ اسمیر"
          />
          <SectionCheckBox
            onChange={(e) =>
              setDataForm({ ...dataForm, cancerTest: e.target.checked })
            }
            checked={dataForm.cancerTest}
            label="غربالگری سرطان پستان"
          />
        </>
      )}

      <SectionCheckBox
        label="روانشناسی"
        onChange={(e) => {
          if ((dataForm?.medicalSections ?? []).indexOf("PSYCHOLOGY") !== -1) {
            setDataForm({
              ...dataForm,
              medicalSections: dataForm?.medicalSections.filter(
                (itr) => itr !== "PSYCHOLOGY",
              ),
            });
          } else {
            let tmp = dataForm?.medicalSections ?? [];
            tmp.push("PSYCHOLOGY");
            setDataForm({
              ...dataForm,
              medicalSections: tmp,
            });
          }
          setCheckedPsychology(e.target.value);
        }}
        checked={checkedPsychology}
      />
      {checkedPsychology && (
        <>
          <SectionCheckBox
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                socialWorkAssistance: e.target.checked,
              })
            }
            checked={dataForm.socialWorkAssistance}
            label="مددکاری اجتماعی"
          />
          <SectionCheckBox
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                quitAddiction: e.target.checked,
              })
            }
            checked={dataForm.quitAddiction}
            label="ترک اعتیاد"
          />
          <SectionCheckBox
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                familyPsychology: e.target.checked,
              })
            }
            checked={dataForm.familyPsychology}
            label="روانشناسی کودک و خانواده"
          />
        </>
      )}

      <SectionCheckBox
        label="آزمایشگاه"
        onChange={(e) => {
          if ((dataForm?.medicalSections ?? []).indexOf("LABORATORY") !== -1) {
            setDataForm({
              ...dataForm,
              medicalSections: dataForm?.medicalSections.filter(
                (itr) => itr !== "LABORATORY",
              ),
            });
          } else {
            let tmp = dataForm?.medicalSections ?? [];
            tmp.push("LABORATORY");
            setDataForm({
              ...dataForm,
              medicalSections: tmp,
            });
          }
          setCheckedLaboratory(e.target.value);
        }}
        checked={checkedLaboratory}
      />
      {checkedLaboratory && (
        <>
          <SectionCheckBox
            style={{ width: "200px" }}
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                urineAnalysis: e.target.checked,
              })
            }
            checked={dataForm.urineAnalysis}
            label="تست آنالیز ادراری"
          />
          <SectionCheckBox
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                bloodCellsCountTest: e.target.checked,
              })
            }
            checked={dataForm.bloodCellsCountTest}
            style={{ width: "270px" }}
            label="تست شمارش سلول‌های خونی"
          />
          <SectionCheckBox
            style={{ width: "180px" }}
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                bioChemTest: e.target.checked,
              })
            }
            checked={dataForm.bioChemTest}
            label="تست بیوشیمی"
          />
          <SectionCheckBox
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                hormonTest: e.target.checked,
              })
            }
            checked={dataForm.hormonTest}
            label="تست هورمونی"
          />
        </>
      )}

      <SectionCheckBox
        label="فیزیوتراپی"
        onChange={(e) => {
          if (
            (dataForm?.medicalSections ?? []).indexOf("PHYSIOTHERAPY") !== -1
          ) {
            setDataForm({
              ...dataForm,
              medicalSections: dataForm?.medicalSections.filter(
                (itr) => itr !== "PHYSIOTHERAPY",
              ),
            });
          } else {
            let tmp = dataForm?.medicalSections ?? [];
            tmp.push("PHYSIOTHERAPY");
            setDataForm({
              ...dataForm,
              medicalSections: tmp,
            });
          }
          setCheckedPhysiotherapy(e.target.value);
        }}
        checked={checkedPhysiotherapy}
      />
      {checkedPhysiotherapy && (
        <>
          <SectionCheckBox
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                movementHelpEquipments: e.target.checked,
              })
            }
            checked={dataForm.movementHelpEquipments}
            label="تجهیزات کمک حرکتی"
          />
        </>
      )}

      <SectionCheckBox
        label="دندانپزشکی"
        onChange={(e) => {
          if ((dataForm?.medicalSections ?? []).indexOf("DENTAL") !== -1) {
            setDataForm({
              ...dataForm,
              medicalSections: dataForm?.medicalSections.filter(
                (itr) => itr !== "DENTAL",
              ),
            });
          } else {
            let tmp = dataForm?.medicalSections ?? [];
            tmp.push("DENTAL");
            setDataForm({
              ...dataForm,
              medicalSections: tmp,
            });
          }
          setCheckedDentistry(e.target.value);
        }}
        checked={checkedDentistry}
      />
      {checkedDentistry && (
        <>
          <SectionCheckBox
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                toothExtraction: e.target.checked,
              })
            }
            checked={dataForm.toothExtraction}
            label="کشیدن دندان"
          />
          <SectionCheckBox
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                dentalRestoration: e.target.checked,
              })
            }
            checked={dataForm.dentalRestoration}
            label="ترمیم دندان"
          />
          <SectionCheckBox
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                toothNerveRemoval: e.target.checked,
              })
            }
            checked={dataForm.toothNerveRemoval}
            label="عصب کشی دندان"
          />

          <SectionCheckBox
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                gumSurgery: e.target.checked,
              })
            }
            checked={dataForm.gumSurgery}
            label="جراحی لثه"
          />
        </>
      )}

      {checkedDentistry && (
        <Grid mr={"25px"} width={"100%"}>
          <AsarFormikInput
            name={"otherDentalServices"}
            label={"سایر اقدامات"}
            placeholder="دیگر اقدامات خود در زمینه دندان پزشکی را نام ببرید."
          />
        </Grid>
      )}

      <SectionCheckBox
        label="ارجاع"
        onChange={(e) => {
          if ((dataForm?.medicalSections ?? []).indexOf("REFERRAL") !== -1) {
            setDataForm({
              ...dataForm,
              medicalSections: dataForm?.medicalSections.filter(
                (itr) => itr !== "REFERRAL",
              ),
            });
          } else {
            let tmp = dataForm?.medicalSections ?? [];
            tmp.push("REFERRAL");
            setDataForm({
              ...dataForm,
              medicalSections: tmp,
            });
          }
          setCheckedErrand(e.target.value);
        }}
        checked={checkedErrand}
      />
      {checkedErrand && (
        <>
          <SectionCheckBox
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                surgeryRefer: e.target.checked,
              })
            }
            label="ارجاع جهت جراحی"
          />
          <SectionCheckBox
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                hospitalizationRefer: e.target.checked,
              })
            }
            label="ارجاع جهت بستری"
          />
          <SectionCheckBox
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                freeRefer: e.target.checked,
              })
            }
            label="ارجاع رایگان بیمار"
          />
        </>
      )}

      {checkedErrand && (
        <Grid mr={"25px"} width={"100%"}>
          <AsarFormikInput
            name={"todootherReferFields"}
            label={"سایر زمینه‌ها"}
            placeholder="دیگر زمینه های فعالیت ارجاع خود را نام ببرید."
          />
        </Grid>
      )}
    </Box>
  );
}
